import { render, staticRenderFns } from "./SettingDiet.vue?vue&type=template&id=4150d961&scoped=true&"
import script from "./SettingDiet.vue?vue&type=script&lang=js&"
export * from "./SettingDiet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4150d961",
  null
  
)

export default component.exports